import { z } from "zod";

/**
 * The same ceiling as `NOTE_BODY_MAX_LENGTH` in `server/app/config/constant.py`
 * and the `candidate_notes.body` column. Change one and change all three.
 */
export const NOTE_BODY_MAX_LENGTH = 4000;

/**
 * Mirrors `_clean_body` in `server/app/api/v2/candidate_note/schema/api.py`:
 * strip the ends, keep the newlines in between, refuse what is left when it is
 * empty, and measure the length *after* the trim so a note that fits is not
 * refused for the spaces around it.
 *
 * The transform runs before the checks, so `handleSubmit` hands the composer a
 * body already trimmed — nothing downstream trims it again.
 */
export const noteSchema = z.object({
  body: z
    .string()
    .transform((value) => (value ?? "").trim())
    .refine((value) => value.length > 0, { message: "A note cannot be empty." })
    .refine((value) => value.length <= NOTE_BODY_MAX_LENGTH, {
      message: `A note cannot be longer than ${NOTE_BODY_MAX_LENGTH} characters.`,
    }),
});

export default noteSchema;
